// extracted by mini-css-extract-plugin
export default {"resultsPage":"IL0R9v","noInsights":"JsEvRx","centeredContent":"T9MDwv","sidePanel":"zLnEfX"};